import { render } from "./Slider.vue?vue&type=template&id=5da8d5b3&scoped=true"
import script from "./Slider.vue?vue&type=script&lang=js"
export * from "./Slider.vue?vue&type=script&lang=js"

import "./Slider.vue?vue&type=style&index=0&id=5da8d5b3&scoped=true&lang=scss"
import "./Slider.vue?vue&type=style&index=1&id=5da8d5b3&lang=scss"

import exportComponent from "/usr/share/nginx/production/goodedition/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5da8d5b3"]])

export default __exports__